import { getAnchorScrollOffset } from './anchorScrollOffset.js'

export default class ScrollAnchorLink {
  scrollToTarget(hash) {
    const $target = $(hash)
    if (!$target.length || $target.hasClass('no-scroll-anchor')) return
    const targetTop = $target.offset().top
    $('html, body').animate(
      { scrollTop: Math.max(0, targetTop - getAnchorScrollOffset(targetTop)) },
      800,
    )
  }

  init() {
    const syncScrollPadding = () => {
      // No target to test against here, so this takes the conservative figure
      // (the sticky bar counted whenever the page has one).
      document.documentElement.style.scrollPaddingTop = `${getAnchorScrollOffset()}px`
    }
    syncScrollPadding()
    $(window).on('resize orientationchange', syncScrollPadding)

    // All anchor links — no class restriction
    $(document).on('click', 'a[href^="#"]', (event) => {
      // The sticky subnav scrolls its own items (it also scrolls the pill
      // horizontally and syncs the active state). Bail before preventDefault so
      // the click still bubbles — other document-level handlers, like the mega
      // menu's close-on-outside-click, must keep seeing it.
      if (event.currentTarget.closest('.sticky-subnav')) return
      const hash = $(event.currentTarget).attr('href')
      if (!hash || hash === '#') return
      if (!$(hash).length) return
      event.preventDefault()
      this.scrollToTarget(hash)
      if (window.location.hash !== hash) {
        history.pushState(null, '', hash)
      }
    })

    // On page load: scroll if URL has a hash matching an existing element
    $(window).on('load', () => {
      syncScrollPadding()
      const { hash } = window.location
      if (hash) {
        this.scrollToTarget(hash)
      }
    })
  }
}

new ScrollAnchorLink().init()
